"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dummyGlProgramSpecification = void 0;
const gl_program_specification_1 = require("../gl-program-specification");
const dummy_shader_1 = require("./dummy-shader");
/**
 * @public
 */
exports.dummyGlProgramSpecification = new gl_program_specification_1.GlProgramSpecification(dummy_shader_1.dummyShader, dummy_shader_1.dummyShader);
//# sourceMappingURL=dummy-gl-program-specification.js.map